export default __webpack_public_path__ + "static/media/loader-goldi-transparent.1438af8b.gif";